import { Input, InputRef } from "antd";
import React, { useEffect, useRef } from "react";

interface Props {
    index: number,
    value?: string,
    currentFocus?: number,
    setInput: (index: number, value: string) => void,
    setCurrentFocus: React.Dispatch<React.SetStateAction<number>>
    onOtpPaste: (value: string) => void
}

const OptSingleInput = ({ currentFocus, index, value, setInput, setCurrentFocus, onOtpPaste }: Props) => {
    const inputRef = useRef<InputRef>(null);

    useEffect(() => {
        if (inputRef.current) {
            if (currentFocus === index) {
                inputRef.current.focus({ cursor: 'all' });
            } else {
                inputRef.current.blur();
            }
        }
    }, [currentFocus, index]);

    const onInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput(index, e.target.value);
    }

    const onFocus = () => {
        inputRef.current!.select();
        setCurrentFocus(index);
    }

    const onPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        let value = e.clipboardData.getData('text');
        onOtpPaste(value);
    }

    return (
        <>
            <Input
                onPaste={onPaste}
                value={value}
                onFocus={onFocus}
                ref={inputRef}
                className="otp-input"
                maxLength={1}
                onInput={onInput} />
        </>
    )
}

export default OptSingleInput;